import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { ExamFeeProcessComponent } from '../exam-fee-process/exam-fee-process.component';
import { ReceiptComponent } from '../receipt/receipt.component';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertboxComponent } from '../alertbox/alertbox.component';
 
@Component({
  selector: 'app-exam-fees',
  templateUrl: './exam-fees.component.html',
  styleUrls: ['./exam-fees.component.scss']
})
export class ExamFeesComponent implements OnInit {
  FeeForm: FormGroup;
  FeeTempletList: any;
  FeeModeList: any;
  FeeTempList: any;
  payBtnShow;
  PayBtn = true;
  PayStatus = false;
  Table = false;
  updateBtn=false
  StuData: any;
  constId = 0;
  StudentType: '';
  StudentStatus: '';
  Constitution: '';
  Caste: '';
  FeeTable: [];
  dialogRef: MatDialogRef<any>;
  feeApplyArray: FormArray;
  xyz = sessionStorage.getItem("StuCoId");
  pqr = sessionStorage.getItem("StuCgId");
  StudentIdd: string;
  FeePaid: string;
  SnNo: any;
  ADMRecords: any;
  ShowMsg = false;
  ShowMsg2 = false;
  Message2 = '';
  Message = '';
  FeeLevel: any;
  collegeName
  courseName
  filteredElements: any;
  errMsg: any;
  StuFeeData: any;
  PayLater = false
  ShowMsg3 = false;
  Message3 = ' '
  sessionList: any[];
  SessionFilterList: any[];
  constructor(private fb: FormBuilder,
    public umsService: UmsService,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService) { }
  FcCode = sessionStorage.getItem("faculty");
  CoCode = sessionStorage.getItem("StuCoId");
  CgCode = sessionStorage.getItem("StuCgId");
  EmId = sessionStorage.getItem("StuEmId");
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  sessionNo = sessionStorage.getItem('session');
  ngOnInit(): void {
    this.ShowMsg = false;
    this.Message = '';
    this.PayBtn = true;
    this.PayStatus = false;
    this.PayLater = false
    this.Table = true;
    this.ShowMsg2 = false
    this.Message2 = ''
    this.ShowMsg3 = false;
    this.Message3 = '';
    sessionStorage.getItem("faculty");
    sessionStorage.getItem("course");
    sessionStorage.getItem("college");
    this.FeeForm = this.fb.group({
 
      feeApplyArray: new FormArray([]),
    })
    this.ValidateFees();
    this.fetchSession()
   
  }
 
  ValidateFees(){
    const payload = {}
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    payload['FeeType'] = 'EF';
    payload['SnNo'] = sessionStorage.getItem('session');
    this.umsService.ValidateFees(payload).subscribe(res => {
      this.getRgId();
    
      this.getFeeModeData();
      this.searchExams();
      this.getSecretData();
    })
  }
 
  getFeeModeData() {
    this.spinner.show();
    const payload = {};
    payload["Session"] = parseInt(this.sessionNo);
    payload['College'] = sessionStorage.getItem("StuCgId"),
      this.umsService.fetchCheckFeeMode(payload).subscribe(res => {
        this.FeeModeList = res.data;
        sessionStorage.setItem('FeeMode', res.data[0].FeeMode);
        this.spinner.hide();
        if (res.data[0].FeeMode == 'ONLIN') {
          this.payBtnShow = true;
         
        } else {
          this.payBtnShow = false;
        
        }
      });
  }
 
  getRgId() {
    const payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.searchEmid(res.data[0]['RgId'])
      
        this.GetEcId(res.data[0]['RgId'])
      }
      else {
      }
    })
  }
 
  searchEmid(RgId) {
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload).subscribe((res) => {
      if (res.status) {
        
      }
    });
  }
 
  submit(emid) {
    let payload = {};
    this.ADMRecords = [];
    payload['SnNo'] = parseInt(this.sessionNo);
    payload['InCode'] = 'EMFEE'
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    this.umsService.CheckValidDate(payload).subscribe(res => {
      if (res.status) {
         const courseRecords = res.data.filter(record => record.CoCgCoCode === sessionStorage.getItem("StuCoId") && record.CoCgCgCode === sessionStorage.getItem("StuCgId") && record.EmId === emid);
        const today = new Date();
        const todayDateString = today.toISOString().split('T')[0];
        
        if (courseRecords.length > 0) {
          this.ADMRecords = courseRecords.filter(record => record.InCode === 'EMFEE');
        }
        let listCanOpen = false;
        if (this.ADMRecords.length == 0) {
           listCanOpen = false;
          this.showAlert('Schedule Not Open For This Activity');
        }
        else if (this.ADMRecords.length > 0) {
          for (let item of this.ADMRecords) {
            if ((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0])) {
              listCanOpen = true;
              break;
            }
          }
        }
 
 
        if (!listCanOpen) {
          for (let item of this.ADMRecords) {
            if (todayDateString > item.ToDate.split('T')[0]) {
              this.showAlert('Exam Fee Due Dates Are Closed For This Exam');
              break;
            } else if (todayDateString < item.FromDate.split('T')[0]) {
              this.showAlert('Schedule Is Not Open For This Activity');
              break;
            }
          }
        }
        if (listCanOpen == true) {
          this.ShowMsg = false;
          this.Message = '';
        }
 
      } else {
        
        this.showAlert('Schedule Is Not Open For This Activity');
      }
    });
 
  }
 
  showAlert(message: string) {
    this.ShowMsg = true
    this.Message = message;
  }
 
  getFeeTempData(EmId,SnNo) {
    this.spinner.show();
    const payload = {};
    payload['SessionId'] = SnNo,
      payload['CoCode'] = sessionStorage.getItem("StuCoId");
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['StuId'] = this.StudentPersonalId;
    payload['FeeType'] = 'EF';
    payload['EmId'] = EmId
    this.umsService.fetchFeeTemp(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
       
        this.getFeeModeData();
        this.FeeTable = res.data;
        this.FeeLevel = res.data[0]['FeeLevel']
        
        this.getcollege(this.CgCode)
        this.getCourse(this.CoCode)
        sessionStorage.setItem('ExamCurrency', res.data[0].Currency)
        this.FeeTable.forEach((element, i) => {
          const creds = this.FeeForm.controls.feeApplyArray as FormArray;
          creds.push(
            this.fb.group({
              StudentName: new FormControl(`${element['StuFirstNameEng']} ${element['StuMidNameEng'] || ''} ${element['StuLastNameEng'] || ''}`.trim()),
              //StudentName: new FormControl(element['StuFirstNameEng'] + " " + element['StuMidNameEng'] + " " + element['StuLastNameEng']),
              TemplateName: new FormControl(element['TemplateName']),
              StuType: new FormControl(),
              StuStatus: new FormControl(),
              StuSocial: new FormControl(),
              StuAdm: new FormControl(),
            })
          );
          this.getStudentType(element['StudentType'], i)
          this.getStudentStatus(element['StudentStatus'], i);
          this.getSocial(element['SocialReservation'], i);
        
          this.getAdmission(element['AdmissionMode'], i);
          
          this.StudentIdd = sessionStorage.getItem("StudentPersonalId");
          this.SearchFeeDetails(res.data[0]['TemplateCode'], this.StudentIdd,SnNo)
        });
        this.Table = true;
      } else {
        this.spinner.hide();
        if (res.message == 'No Data Found') {
          
          this.FeeTable = [];
        }
 
      }
    });
  }
 
  getcollege(CgCode) {
    const payload = {};
    payload['CgCode'] = CgCode
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeName = res.data[0].CgName;
 
    }, (ERROR: HttpErrorResponse) => {
      
      this.spinner.hide();
    })
  }
 
 
  getCourse(CoCode) {
    const payload = {};
    payload['CoCode'] = CoCode
    this.umsService.fetchCourseType(payload).subscribe(res => {
      this.spinner.hide();
      this.courseName = res.data[0].CoName;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
 
  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.SnNo = res.projectPharam['SnNo']
    })
  }
 
  SearchFeeDetails(TempCode, StdId,SnNo) {
    this.spinner.show();
    const payload = {};
    
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StdId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = SnNo
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        if (this.FeeLevel == 'SW' && res.data[0]['FeeStatus'] != 'N') {
          if (res.data[0]['TotalPaidAmount'] == 0) {
            this.PayBtn = false;
            this.PayStatus = true;
            this.updateBtn = true;
            this.FeePaid = 'Wave Off'
          }
        else  if (res.data.FeeAmt == res.data.TotalPaidAmount) {
            this.PayBtn = false;
            this.PayStatus = true;
            this.PayLater = false
            this.FeePaid = 'Fees Paid'
          }
          else if (res.data.FeeAmt != res.data.TotalPaidAmount) {
            this.PayBtn = true;
            this.PayStatus = false;
            this.PayLater = false
          }
        }
        else if (this.FeeLevel == 'EW' && res.data[0]['FeeStatus'] != 'N') {
          let data = 0
          res.data.forEach(element => {
            data += element.FeeAmount
          });
          this.PayLater = false
          if (res.data[0]['TotalPaidAmount'] == 0) {
            this.PayBtn = false;
            this.PayStatus = true;
            this.updateBtn = true;
            this.FeePaid = 'Wave Off'
          }
          else if (data == res.data[0]['TotalPaidAmount']) {
            this.PayBtn = false;
            this.PayStatus = true;
            this.FeePaid = 'Fees Paid'
          }
          else if (data != res.data[0]['TotalPaidAmount']) {
            this.PayBtn = true;
            this.PayStatus = false;
          }
 
 
        }
        if (res.data[0]['FeeStatus'] == 'N') {
          this.FeePaid = 'Pay Later';
          this.PayStatus = false;
          this.PayBtn = false;
          this.PayLater = true;
          this.payBtnShow = true;
        }
 
 
      }
      else {
 
      }
    });
 
  }
 
 
  searchExams2(RgId) {
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
        else {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
 
      }
    });
  }
 
  GetEcId(RgId){
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.GetEcId(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
          this.submit(res.data[0]['EmId'])
          this.EmId = res.data[0]['EmId']
        this.getFeeTempData(res.data[0]['EmId'],this.sessionNo)
        }
        else {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
          this.submit(res.data[0]['EmId'])
          this.EmId = res.data[0]['EmId']
        this.getFeeTempData(res.data[0]['EmId'],this.sessionNo)
        }
 
      }
    });
  }
 
  ExmFormSub(EcId, RgId) {
    this.ShowMsg2 = false;
    this.filteredElements = []
    this.spinner.show();
    const payload = {};
    payload['EcId'] = EcId;
    payload['RgId'] = RgId;
    this.umsService.ExmFormSub(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ShowMsg2 = false
        this.filteredElements = res.data.filter(element => {
          if (element.EsType == 'S' && (element.App == 'Y' || element.App == ' ')) {
            return element
          }
        });
        if (this.filteredElements.length == 0) {
          this.ShowMsg3 = true;
          this.Message3 = 'Not Eligible To Pay Exam Fees As All Subjects Have Attendance Deficiency'
          this.PayStatus = false;
          this.payBtnShow = false;
          this.getFeeDetails();
          
        }
        else if (this.filteredElements.length != 0) {
          this.ShowMsg3 = false;
          this.Message3 = ' '
        }
      }
      else{
        this.ShowMsg2 = true
        this.Message2 = 'First Submit Exam Form'
        this.Table = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
 
  getFeeDetails() {
    this.StuFeeData = []
    let payload = {}
    payload['SessionId'] = this.sessionNo
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    payload['CgCode'] = sessionStorage.getItem("StuCgId")
    payload['StuId'] = this.StudentPersonalId
    payload['FeeType'] = 'EF'
    this.umsService.getFeeDetails(payload).subscribe((res) => {
      if (res.status) {
        this.StuFeeData = res.data.filter(item => item.StuId == this.StudentPersonalId)
        this.searchFee();
      }
      else {
 
      }
    })
  }
 
  searchFee() {
    const payload = {};
    
    payload['FeeTemplateCode'] = this.StuFeeData[0]['TemplateCode'];
    payload['StuId'] = this.StuFeeData[0]['StuId'];
    payload['FeeHistory'] = 0;
    payload['SnNo'] = this.sessionNo
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      if (res.status == false && res.message == 'No Data Found') {
        this.PayStatusFees();
      }
    })
  }
 
  PayStatusFees() {
    this.spinner.show();
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.StuFeeData.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            FeeTemplateCode: new FormControl(element.TemplateCode), //add neww
            StuId: new FormControl(this.StudentPersonalId),
            FeeType: new FormControl('EF'),
            FeeHead: new FormControl(element.Head),
            FeeStatus: new FormControl('N'),
            FeeAmt: new FormControl(element.FeeAmount),
            FeePaid: new FormControl(0),
            FeeDue: new FormControl(element.FeeAmount),
            FeeDueDummy: new FormControl(element.FeeAmount),
            FeePaymentMethod: new FormControl(''),
            TotalPaidAmount: new FormControl(0),
            PayMode: new FormControl(''),
            SnNo: new FormControl(this.sessionNo),
            CreatedBy: new FormControl(''),
          })
        )
        this.umsService.addFeeTemplet(arr1[0].value).subscribe(res => {
          this.spinner.hide();
 
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          else {
            iserror = false
            this.errMsg = res.message
          }
        },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          }
        );
      });
    })
    bar.then(() => {
    });
  }
 
 
  getfeeApplyArrayControls() {
    return (this.FeeForm.get('feeApplyArray') as FormArray).controls;
  }
 
  Download(item) {
    let data = item
    const dialogRef4 = this.dialog.open(ReceiptComponent,
 
      {
        data,
        disableClose: true,
        width: "900px",
        height: "auto",
      });
    dialogRef4.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });
  }
 
  openFeeProcessPopUp(item) {
    
    let data = {};
    data['EmId'] = this.EmId
    sessionStorage.setItem('TemplateCode', item.TemplateCode);
    const dialogRef4 = this.dialog.open(ExamFeeProcessComponent,
      {
        disableClose: true,
        width: "900px",
        height: "80vh",
        data
      });
    dialogRef4.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });
  }
 
 
  getStudentType(id, i) {
    const payload = {};
    payload['CdType'] = 'STYPE'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuType').setValue(element['CdDesc']);
        });
      }
    });
  }
 
  getStudentStatus(id, i) {
    const payload = {};
    payload['CdType'] = 'STUST'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuStatus').setValue(element['CdDesc']);
        });
      }
    });
  }
 
  getSocial(id, i) {
    const payload = {};
    payload['CdType'] = 'SR'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuSocial').setValue(element['CdDesc']);
        });
      }
    });
  }
 
  getAdmission(id, i) {
    const payload = {};
    payload['CdType'] = 'AMODE'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuAdm').setValue(element['CdDesc']);
        });
      }
    });
  }
 
 
  searchExams() {
    let payload = {};
    this.Table = false;
    this.ShowMsg2 = false
    this.Message2 = ''
    payload['RgNo'] = sessionStorage.getItem('StudentRGID');
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['Valid'] = '';
    payload['Chng'] = '';
    payload['App'] = '';
    payload['EfId'] = 0
    this.umsService.fetchInputExams(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['Valid'] == 'X') {
          this.Table = false;
          this.ShowMsg2 = true
          this.Message2 = 'First Submit Exam Form'
        }
        else {
          this.Table = true;
          this.ShowMsg2 = false
          this.Message2 = ''
        }
      } else {
        this.Table = false;
      }
    });
  }
 
  addnewrecord(item) {
    let data = {};
    data['SnNo'] = this.sessionNo
    data['TemplateCode'] = item.TemplateCode
    data['Fee'] = 'Examination Payment Receipt'
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      // width: '80vh',
      // height: '80vh',
      width: 'auto',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
     
    });
  }

  fetchSession() {
    this.spinner.show();
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = ''; 
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
   })
  }
 
  onSelect(SnNo) {
    // Return the selected session object when closing the dialog
    
    this.spinner.show();
    const payload = {};
    payload['RgNo'] = parseInt(sessionStorage.getItem('StudentRGID'))
    payload['SnNo'] = SnNo; 
    this.umsService.AllSnNoReports(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.getFeeTempData(res.data[0]['EfEmId'],SnNo)
        this.sessionNo = SnNo
      }
      else{
        let data = {}
        data['message'] = 'No Data Found For This Session'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.Table = false;
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
        data['message'] = 'No Data Found For This Session'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.Table = false
   })
  }
}